export default __webpack_public_path__ + "static/media/weight-loss_female-doctor.15481338.jpg";